import React from 'react';
import { Instagram, Music } from 'lucide-react';
import { SOCIAL_LINKS } from '../mock/mock';

export default function Footer() {
  return (
    <footer className="bg-brown text-cream mt-0">
      {/* Giant logo band */}
      <div className="px-5 md:px-10 pt-16 pb-12 border-b border-cream/20 flex justify-center">
        <img
          src="https://customer-assets.emergentagent.com/job_latindex-shop/artifacts/77loiwsl_4ece5f13-27f5-4ece-82ec-d7db4259eac7%20-%20Edited.png"
          alt="Mariah Angeliq"
          className="w-[60vw] md:w-[40vw] max-w-[520px] h-auto object-contain"
        />
      </div>

      <div className="max-w-[1600px] mx-auto px-5 md:px-10 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <h4 className="font-anton uppercase tracking-widest text-pink text-sm mb-4">Shop</h4>
          <ul className="space-y-2 font-body text-sm">
            <li><a href="/shop" className="hover:text-pink-hot transition-colors">All Products</a></li>
            <li><a href="/shop?cat=music" className="hover:text-pink-hot transition-colors">Music</a></li>
            <li><a href="/shop?cat=apparel" className="hover:text-pink-hot transition-colors">Apparel</a></li>
            <li><a href="/shop?cat=accessories" className="hover:text-pink-hot transition-colors">Accessories</a></li>
            <li><a href="/shop?cat=posters" className="hover:text-pink-hot transition-colors">Posters</a></li>
          </ul>
        </div>
        <div>
          <h4 className="font-anton uppercase tracking-widest text-pink text-sm mb-4">Explore</h4>
          <ul className="space-y-2 font-body text-sm">
            <li><a href="/#about" className="hover:text-pink-hot transition-colors">About</a></li>
            <li><a href="/#music" className="hover:text-pink-hot transition-colors">Music</a></li>
            <li><a href="/#tour" className="hover:text-pink-hot transition-colors">Tour</a></li>
            <li><a href="/#gallery" className="hover:text-pink-hot transition-colors">Gallery</a></li>
            <li><a href="/#press" className="hover:text-pink-hot transition-colors">Press</a></li>
          </ul>
        </div>
        <div>
          <h4 className="font-anton uppercase tracking-widest text-pink text-sm mb-4">Help</h4>
          <ul className="space-y-2 font-body text-sm">
            <li><a href="#" className="hover:text-pink-hot transition-colors">Shipping</a></li>
            <li><a href="#" className="hover:text-pink-hot transition-colors">Returns</a></li>
            <li><a href="#" className="hover:text-pink-hot transition-colors">Order Tracking</a></li>
            <li><a href="#" className="hover:text-pink-hot transition-colors">Contact</a></li>
            <li><a href="#" className="hover:text-pink-hot transition-colors">FAQ</a></li>
          </ul>
        </div>
        <div>
          <h4 className="font-anton uppercase tracking-widest text-pink text-sm mb-4">Follow</h4>
          <div className="flex items-center gap-4 mb-5">
            <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-cream/10 hover:bg-pink-hot flex items-center justify-center transition-colors">
              <Instagram className="w-5 h-5" />
            </a>
            <a href={SOCIAL_LINKS.spotify} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-cream/10 hover:bg-pink-hot flex items-center justify-center transition-colors">
              <Music className="w-5 h-5" />
            </a>
          </div>
          <p className="font-body text-xs text-cream/70">Get tour dates, drops & exclusive offers.</p>
        </div>
      </div>

      <div className="border-t border-cream/20">
        <div className="max-w-[1600px] mx-auto px-5 md:px-10 py-5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="font-body text-xs text-cream/70">© {new Date().getFullYear()} Mariah Angeliq. All rights reserved.</p>
          <div className="flex items-center gap-5 font-body text-xs text-cream/70">
            <a href="#" className="hover:text-pink-hot transition-colors">Privacy</a>
            <a href="#" className="hover:text-pink-hot transition-colors">Terms</a>
            <a href="#" className="hover:text-pink-hot transition-colors">Accessibility</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
